import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  key: 1,
  id: "valutino-img",
  "class": "tw-absolute -tw-top-10 tw-right-0"
};
var _hoisted_6 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_autocomplete = _resolveComponent("base-autocomplete");
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass(["tw-relative", _ctx.$attrs['class']])
  }, [_createElementVNode("p", {
    "class": _normalizeClass([_ctx.titleClass, "tw-text-18 tw-font-semibold tw-mb-5px"]),
    innerHTML: _ctx.labels.valuatenow
  }, null, 10 /* CLASS, PROPS */, _hoisted_1), _ctx.valuationBannerParagraph ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    "class": _normalizeClass(_ctx.valuationBannerParagraphClass ? _ctx.valuationBannerParagraphClass : "tw-text tw-font-regular tw-inline-block"),
    innerHTML: _ctx.valuationBannerParagraph
  }, null, 10 /* CLASS, PROPS */, _hoisted_2)) : _createCommentVNode("v-if", true), _createVNode(_component_base_autocomplete, {
    id: "".concat(_ctx.$attrs.id || '', "_valuation-banner-autocomplete"),
    ref: "valuationBannerAC",
    modelValue: _ctx.valuationAddress,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.valuationAddress = $event;
    }),
    "data-cy": "".concat(_ctx.$attrs.id || '', "_valuation-banner-autocomplete"),
    "class": "tw-mt-15px tw-rounded",
    placeholder: _ctx.labels.enterAddress,
    "on-input-change-cb": _ctx.onInputChangeCb,
    "on-option-selected-cb": _ctx.optionSelectedCb,
    "disable-cb": _ctx.disableCb,
    onClick: _cache[2] || (_cache[2] = function ($event) {
      _ctx.disableCb = false;
      _ctx.$refs.valuationBannerAC.select();
    })
  }, {
    lefticon: _withCtx(function () {
      return [_createElementVNode("img", {
        src: "".concat(_ctx.cdn, "/_ui/img/Ico/place.svg"),
        "class": "text-input-icon left sm",
        alt: "search Icon"
      }, null, 8 /* PROPS */, _hoisted_3)];
    }),
    righticon: _withCtx(function () {
      return [_createElementVNode("img", {
        id: "vb-search-icon",
        src: "".concat(_ctx.cdn, "/_ui/img/Ico/search-white.svg"),
        "class": "text-input-icon right tw-bg-w-secondary !tw-p-[7px] !tw-size-30px !tw-top-5px tw-rounded tw-cursor-pointer tw-z-[1]",
        width: "30",
        height: "30",
        alt: "Search Icon",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
        //@ts-ignore
        function () {
          return _ctx.submit && _ctx.submit.apply(_ctx, arguments);
        }, ["stop", "prevent"]))
      }, null, 8 /* PROPS */, _hoisted_4)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["id", "modelValue", "data-cy", "placeholder", "on-input-change-cb", "on-option-selected-cb", "disable-cb"]), _ctx.valutinoIsVisible ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
    width: "100",
    src: "".concat(_ctx.cdn, "/_ui/img/Ico/nerd-valuta-listato.svg"),
    alt: "Immagine valuta"
  }, null, 8 /* PROPS */, _hoisted_6)])) : _createCommentVNode("v-if", true)], 2 /* CLASS */);
}